import { TokenService } from 'src/app/services/token/token.service';
import { AppConfig } from 'src/app/app.config';
import { Injectable } from "@angular/core";
import { Router } from '@angular/router';
import { Features } from 'src/app/models/features';
import { UserRoleType } from "src/app/models/userRoleTypes";
import { AuthService } from "../http/auth.service";

@Injectable()
export class ClientHomeRouteService {
    constructor(private router: Router, private appConfig: AppConfig, private tokenService: TokenService, private authService: AuthService) {}

    public redirectToHome() {
        const useOldView = this.appConfig.getSection(Features.OLD_VIEW);
        const clientHome = this.appConfig.getSection(Features.CLIENT_HOME);
        if (this.tokenService.isAdministrator() || this.authService.doesUserHaveRole(UserRoleType.Advisor)) {
            this.router.navigate(['/feature', 'dashboard']);
        } else {
            if (clientHome) {
                this.router.navigate([clientHome]);
            } else {
                if (useOldView.enabled) {
                    this.router.navigate(['/feature', 'client', 'summary']);
                } else {
                    this.router.navigate(['/feature', 'client', 'dashboard']);
                }
            }
        }
    }
}
